import React from "react";
import { InputGroup, Label, Input } from "reactstrap";
import { Controller } from "react-hook-form";

export const InputGrouped = ({
  button,
  name,
  label,
  disabled,
  control,
  required,
  defaultValue,
}) => (
  <Controller
    rules={{ required }}
    name={name}
    control={control}
    render={({ field: { onChange, value } }) => (
      <div className="p-0">
        {label && (
          <Label for={name} disabled={disabled}>
            {label}
            {required && <span className="text-danger">*</span>}
          </Label>
        )}
        <InputGroup>
          {button}
          <Input
            disabled={disabled}
            onChange={onChange}
            value={value}
            defaultValue={defaultValue}
          />
        </InputGroup>
      </div>
    )}
  />
);
